import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Quote, Star, ChevronLeft, ChevronRight } from "lucide-react";

export default function TestimonialsCarousel() {
    const [items, setItems] = useState([]);
    const [i, setI] = useState(0);

    useEffect(() => {
        api.get("/testimonials")
            .then((r) => setItems((r.data || []).filter((t) => t.published !== false)))
            .catch(() => setItems([]));
    }, []);

    useEffect(() => {
        if (items.length <= 1) return;
        const t = setInterval(() => setI((prev) => (prev + 1) % items.length), 7000);
        return () => clearInterval(t);
    }, [items.length]);

    if (!items.length) return null;
    const t = items[i];
    const go = (dir) => setI((p) => (p + dir + items.length) % items.length);

    return (
        <section className="py-16 sm:py-24 bg-white" data-testid="testimonials-carousel">
            <div className="max-w-4xl mx-auto px-6 sm:px-10 text-center">
                <div className="eyebrow mx-auto mb-6"><Quote className="w-3.5 h-3.5" /> Testemunhos</div>
                <h2 className="font-display text-3xl sm:text-5xl font-bold tracking-tight leading-[1.05] mb-12">
                    O que dizem os nossos <span className="font-serif-italic text-[hsl(var(--copper))]">clientes</span>.
                </h2>

                <div className="relative">
                    <div className="card-stone p-8 sm:p-12 text-left" key={t.id}>
                        <div className="flex gap-0.5 mb-5" aria-label={`${t.rating || 5} de 5 estrelas`}>
                            {Array.from({ length: t.rating || 5 }).map((_, k) => (
                                <Star key={`${t.id}-star-${k}`} className="w-4 h-4 fill-[hsl(var(--copper))] text-[hsl(var(--copper))]" />
                            ))}
                        </div>
                        <p className="font-serif-italic text-2xl sm:text-3xl leading-relaxed text-[hsl(var(--graphite))] mb-8" data-testid="testimonial-comment">
                            "{t.comment}"
                        </p>
                        <div className="flex items-center justify-between flex-wrap gap-4 pt-6 border-t border-[hsl(var(--border))]">
                            <div>
                                <div className="font-display font-bold text-[hsl(var(--graphite))]">{t.name}</div>
                                <div className="text-sm text-[hsl(var(--graphite))]/60">
                                    {t.work}{t.work && t.location ? " · " : ""}{t.location}
                                </div>
                            </div>
                            {items.length > 1 && (
                                <div className="flex items-center gap-2">
                                    <button type="button" onClick={() => go(-1)} aria-label="Anterior" data-testid="testimonial-prev"
                                        className="w-10 h-10 rounded-full border border-[hsl(var(--border))] hover:border-[hsl(var(--copper))] hover:text-[hsl(var(--copper))] flex items-center justify-center transition">
                                        <ChevronLeft className="w-4 h-4" />
                                    </button>
                                    <button type="button" onClick={() => go(1)} aria-label="Seguinte" data-testid="testimonial-next"
                                        className="w-10 h-10 rounded-full border border-[hsl(var(--border))] hover:border-[hsl(var(--copper))] hover:text-[hsl(var(--copper))] flex items-center justify-center transition">
                                        <ChevronRight className="w-4 h-4" />
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>

                    {items.length > 1 && (
                        <div className="flex items-center justify-center gap-2 mt-6">
                            {items.map((it, k) => (
                                <button
                                    key={`dot-${it.id || k}`}
                                    type="button"
                                    onClick={() => setI(k)}
                                    aria-label={`Ir para ${k + 1}`}
                                    data-testid={`testimonial-dot-${k}`}
                                    className={`h-1.5 rounded-full transition-all ${k === i ? "w-8 bg-[hsl(var(--copper))]" : "w-4 bg-[hsl(var(--graphite))]/20 hover:bg-[hsl(var(--graphite))]/40"}`}
                                />
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </section>
    );
}
